export const ACCEPT_FILE_TYPES = [
  "png",
  "jpg",
  "jpeg",
  "bmp",
  "gif",
  "tiff",
  "pdf",
  "doc",
  "docx",
  "xlsx",
  "xls",
  "ppt",
  "pptx",
  "mp3",
  "mp4",
  "webm",
  "webp",
  "aac",
  "wav",
  "ogg",
  "m4a",
  "avi",
  "mov",
  "txt",
  "csv",
  "xml",
  "rtf",
  "md",
  "c",
  "h",
  "cpp",
  "java",
  "py",
  "cs",
  "go",
  "php",
  "json",
  "asm",
  "sh",
  "bat",
  "zip",
  "rar",
  "7z",
  "tar",
  "gz",
  "bz2",
];